import { AsyncFetchStatus } from './AsyncFetchStatus';

export const checkFetchStatus = (fetchStatus: AsyncFetchStatus): boolean => {
	return fetchStatus === AsyncFetchStatus.INITIAL || fetchStatus === AsyncFetchStatus.IDLE;
};

export const checkFetchStatusPending = (fetchStatus: AsyncFetchStatus): boolean => {
	return fetchStatus === AsyncFetchStatus.INITIAL_PENDIG || fetchStatus === AsyncFetchStatus.PENDING;
};
